(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-product-quick-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var targets = {
      overview: '.mh-product-content, .product-information',
      highlights: '.mh-product-content__highlights',
      details: '.mh-product-content__details, [data-testid="product-information-details"] .rte',
      styling: '[data-merowen-pillow-product-section-type="story"], [data-merowen-tapestry-product-section-type="styling"], [data-merowen-tapestry-product-section-type="story"], [data-merowen-macrame-product-section="craft-stages"], [data-merowen-macrame-product-section="story"]',
      shipping: '[data-merowen-pillow-product-section-type="policy"], [data-merowen-tapestry-product-section-type="policy"], [data-merowen-macrame-product-section="policy-links"]',
      reviews: '#judgeme_product_reviews, .jdgm-rev-widg',
      questions: '[data-merowen-pillow-product-section-type="contact"], [data-merowen-tapestry-product-section-type="contact"], [data-merowen-macrame-product-section="contact"]'
    };

    function initializeNavigation(scope) {
      var navigations = scope.querySelectorAll ? scope.querySelectorAll('[data-mh-quick-nav]') : [];
      navigations.forEach(function (navigation) {
        var visibleCount = 0;
        navigation.querySelectorAll('[data-mh-quick-target]').forEach(function (trigger) {
          var target = document.querySelector(targets[trigger.dataset.mhQuickTarget]);
          trigger.hidden = !target;
          if (target) visibleCount += 1;
        });
        navigation.hidden = visibleCount === 0;
      });
    }

    initializeNavigation(document);
    document.addEventListener('shopify:section:load', function (event) {
      initializeNavigation(event.target);
    });

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-mh-quick-target]');
      if (!trigger || trigger.hidden) return;
      var target = document.querySelector(targets[trigger.dataset.mhQuickTarget]);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
